import React from "react";

interface Props {
  base64?: string | null;
}

/**
 * 🧾 QzTrayPreviewText
 *
 * Muestra el contenido textual del ticket (decodificado desde Base64)
 * con estilo realista tipo ticket térmico.
 */
const QzTrayPreviewText: React.FC<Props> = ({ base64 }) => {
  const decodedText = base64
    ? atob(base64)
    : "⚠️ Sin contenido de ticket disponible.";

  return (
    <div className="flex justify-center w-full mt-5">
      <div className="w-[280px] sm:w-[300px] rounded-lg border border-stroke dark:border-strokedark bg-white dark:bg-boxdark shadow-sm overflow-hidden">
        {/* 🔹 Encabezado visual */}
        <div className="border-b border-stroke dark:border-strokedark bg-gray-100 dark:bg-gray-800 px-3 py-2 text-center">
          <h4 className="text-xs font-semibold text-gray-700 dark:text-gray-200 tracking-wide uppercase">
            Contenido del ticket
          </h4>
        </div>

        {/* 🧾 Cuerpo del ticket */}
        <div className="p-4 font-mono text-[12.5px] leading-relaxed text-gray-800 dark:text-gray-200 whitespace-pre-wrap text-center">
          {decodedText}
        </div>

        {/* 🔸 Pie de borde */}
        <div className="h-2 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-800 dark:via-gray-700 dark:to-gray-800"></div>
      </div>
    </div>
  );
};

export default QzTrayPreviewText;
